import { For, Show, onMount } from "solid-js";
import { Progress } from "../components/progress";
import { A, Link, useRouteData } from "@solidjs/router";
import { UserSession, FacultyMember } from "../types";
import { fetchGet } from "../library/common";
import toast from "solid-toast";
import { getArtworksCountJson, limits, loadFacultyCms as loadFacultyCms } from "../app";
import { createStore } from "solid-js/store";
import { CMS } from "../components/cms/cms";
import { MultiProgress } from "../components/multi-progress";
import { FacultyMemberItem } from "../components/faculty-member-item";
import { MultiProgressPanel } from "../components/multi-progress-panel";
import { PageLoading } from "../components/page-loading";
import { SectionHeader } from "../components/section-header";

type State = {
    isContentReady: boolean;
}

export function Faculty() {
    const { min, max } = limits.faculty;
    const [session, setSession] = createStore<UserSession>({ } as UserSession);
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [facultyMembers, setFacultyMembers] = createStore<FacultyMember[]>([]);
    const count = () => facultyMembers.length;
    const canApply = true;
    const toastSuccess = (msg: string) => {
        toast.success(msg);
    }
    const toastError = (msg: string) => {
        toast.error(msg);
    }
    const onDeleteClicked = async (id: string) => {
        const params = { id };
        const response = await fetchGet("/AtelierApplication/DeleteFacultyMemberJson", params);
        const json = await response.json();
        if (!json.Success) {
            return toastError("Unable to remove the faculty member from your application at this time.");
        }
        const remaining = facultyMembers.filter(x => x.Id != id);
        setFacultyMembers(remaining);
        await getArtworksCountJson({ forceRefresh: true });
        toastSuccess("The faculty member has been removed from your application.")
    };
    onMount(async() =>{
        const routeData = await useRouteData() as any;
        await loadFacultyCms();
        setSession(routeData.session);
        setFacultyMembers(routeData.facultyMembers);
        setState({ isContentReady: true });
    });
    return (
        <>
            <SectionHeader>
                <h1>
                    Faculty Members
                </h1>
                <p>
                    <a href="/"><CMS text id="nav::home">Home</CMS></a> / <A href="/introduction"><CMS text id="nav::atelier-application">ARC Atelier Application</CMS></A>
                </p>
            </SectionHeader>
            <Show when={state.isContentReady} fallback={<PageLoading />}>
                <div>
                    <Progress step={2}></Progress>
                    <Show when={canApply}>
                        <div class="row ">
                            <div class="col-md-8">
                                <p style="font-size: 1.5em;">
                                    You may enter up to {max} faculty members, along with a short bio and photo of each.
                                </p>
                            </div>
                            <div class="col-md-4">
                                <div class="pull-right">
                                    <MultiProgressPanel
                                        count={count}
                                        min={min}
                                        max={max}
                                        entity="faculty member"
                                    />
                                    <div style="margin-top: 40px;">
                                        <Link class="btn btn-chunky-lg btn-chunky-dark-grey" href={"/details"} style={{ "margin-right": "10px"}}>
                                            <CMS id="button::back" text>Back</CMS>
                                        </Link>
                                        <Show when={count() >= min}>
                                            <A class="btn btn-chunky-lg btn-chunky-goldenrod" href={"/instructor-works"}><CMS id="button::next" text>Next</CMS></A>
                                        </Show>
                                        <Show when={count() < min}>
                                            <CMS id="button::next" text>Next</CMS>
                                        </Show>
                                    </div>
                                    <Show when={count() < max}>
                                        <div style="margin-top: 20px;">
                                            <A class="btn btn-primary" href={"/add-faculty-member"}><span style="margin-right: 10px;" class="fa fa-plus-circle"></span>
                                                <CMS id="button::add-artwork" text>Add Faculty Member</CMS>
                                            </A>
                                        </div>
                                    </Show>
                                </div>
                            </div>
                        </div>
                    </Show>
                    <div class="row">
                        <For each={facultyMembers}>{(facultyMember) =>
                            <FacultyMemberItem
                                resources={{ canApply }}
                                session={session}
                                deleteClicked={onDeleteClicked}
                                facultyMember={facultyMember}
                            />
                        }</For>
                        <Show when={count() < max}>
                            <div class="artwork-container add-artwork-container">
                                <div style="display: table; margin: 0 auto;">
                                    <div style="display: table-row;">
                                        <div style="display: table-cell; height: 300px; vertical-align: middle;">
                                            <Link class="btn btn-success" style="font-size: 2em;" href={ "/add-faculty-member" }>
                                                <span style="margin-right: 10px;" class="fa fa-plus-circle"></span><CMS id="button::add-faculty-member" text>Add Faculty Member</CMS>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Show>
                    </div>
                </div>
            </Show>
        </>
    )
}